import { Contractor } from "../contract.entities"

import { Contract } from "../contract.entities"

export enum ServiceProviderStatus {
	APPROVED = 'approved',
	PENDING = 'pending',
	DECLINED = 'declined',
	DEACTIVATED = 'deactivated',
	REAPPROVE = 'reapprove',
}

export type TerminateContractsResult = {
	totalContracts: number,
	terminatedCount: number,
	failedCount: number,
	kafkaEventsSent: number,
	kafkaEventsFailed: number
}

export type CleanupResult = {
	deletedCount: number
	totalThreads: number 
	errors: string[]
}

export type GenerateViewContractsTokenResponse = {
	token: string
	expiresIn: string
	isReadonly: boolean
}

export type GetContractsAndContractorsResponse = {
	contractors: Contractor[],
	contractsByContractor: Record<string, Contract[]>,
	clientNames: Record<string, string>,
	isReadonly: boolean
}

export namespace Features {
	export type Feature = {
		id: string
		status: FeatureStatus
	}

	export enum FeatureStatus {
		ENABLED = 'enabled',
		DISABLED = 'disabled',
		BETA = 'beta'
	}

	export enum FeatureEnum {
		SERVICE_DESIGNER_TEMPLATES = 'service-designer-templates',
		SERVICE_PROVIDER_CHECKLIST = 'service-provider-checklist',
		PEAK_SYNC = 'peak-sync',
		CONTRACT_MANAGEMENT = 'contract-management',
		AI_TRANSLATIONS = 'AI-translations',
		AI_PRODUCT_CATEGORIES = 'AI-product-categories',
		AI_CUSTOMER_SEGMENTS = 'AI-customer-segments',
		AI_IMAGE_ENHANCER = 'AI-image-enhancer'
	}

	export const ClientFeatures = {
		CONTRACT_MANAGEMENT: {
			id: FeatureEnum.CONTRACT_MANAGEMENT,
			status: FeatureStatus.ENABLED
		},
		AI_TRANSLATIONS: {
			id: FeatureEnum.AI_TRANSLATIONS,
			status: FeatureStatus.ENABLED
		},
		AI_PRODUCT_CATEGORIES: {
			id: FeatureEnum.AI_PRODUCT_CATEGORIES,
			status: FeatureStatus.ENABLED
		},
		AI_CUSTOMER_SEGMENTS: {
			id: FeatureEnum.AI_CUSTOMER_SEGMENTS,
			status: FeatureStatus.ENABLED
		},
		AI_IMAGE_ENHANCER: {
			id: FeatureEnum.AI_IMAGE_ENHANCER,
			status: FeatureStatus.ENABLED
		}
	} as const
}